// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "footer .subscribe[data-v-87578e38]{max-width:350px}footer .footer__heading[data-v-87578e38]{font-weight:500;max-width:100%}footer a:hover svg path[data-v-87578e38]{fill:#9ae17b}footer .footer-menu li[data-v-87578e38]{padding-bottom:4px}footer .footer-menu li a[data-v-87578e38]{color:#b2b2b2;font-size:14px;font-weight:400;text-transform:capitalize}footer .footer-menu li a[data-v-87578e38]:hover{color:#9ae17b}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
